import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=69eca0b0&"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports